import React, { useEffect, useRef, useState } from 'react';
import DeviceUserIconBlack from '../../images/DeviceUserIconBlack';
import {
  createDeviceUser,
  DeviceUserPayload,
  EmployeePayload,
  getDetailDeviceUser,
  getListDeviceUserRole,
  getListEmployees,
  updateDeviceUser,
} from '../../services/deviceUser.service';
import LocationsIcon from '../../images/LocationsIcon';
import LeftIcon from '../../images/LeftIcon';
import { webLoadingFalse, webLoadingTrue, webNavigate } from '../../services/navigate.service';
import { getLocations } from '../../services/inventoryCorrections.service';
import { validateNoSpecialChars } from '../../validation/ValidationInput';
import { showToast } from '../../services/toast.service';
import { showApiError } from '../../services/apiError';
import { coreFormLimits, limitProps, useFieldLimits, validateAgainstLimits } from '../../services/fieldLimits';
import FieldCounter from '../../components/FieldCounter';
import BackIcon from '../../images/BackIcon';
import CheckIconWhite from '../../images/CheckIconWhite';
import { DropdownSearch } from '../../components/DropdownSearch';
import { useResponsive } from '../../hook/useResponsive';
import { useFormKeyboard } from '../../hook/useFormKeyboard';

export interface CountryResponse {
  name: string;
  id: string;
  isSelect: boolean;
}

interface ListCountryResponse {
  name: string;
  locationId: string;
}

interface DeviceUserRoleResponse {
  roleName: string;
  id: string;
}

interface EmployeesResponse {
  firstName: string;
  lastName: string;
  id: string;
}

interface ListCountrySelect {
  id: string;
}

const DeviceUserDetail = () => {
  const [language, setLanguage] = useState<any>(null);
  const limits = useFieldLimits(coreFormLimits('device-user'));
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const dropdownUserRoleRef = useRef<HTMLDivElement>(null);
  const dropdownEmployeeRef = useRef<HTMLDivElement>(null);
  const path = window.location.pathname;
  const id: string = path.split('/').pop() || '';
  const preLanguage = localStorage.getItem('language');
  const userId = localStorage.getItem('userId') || '';
  const companyId = localStorage.getItem('companyId') || '';
  const [listCountrySelect, setListCountrySelect] = useState<ListCountrySelect[]>([]);
  const [country, setCountry] = useState<CountryResponse[]>([]);
  const [isUserRoleDropdownOpen, setIsUserRoleDropdownOpen] = useState(false);
  const [searchUserRole, setSearchUserRole] = useState('');
  const [isEmployeeDropdownOpen, setIsEmployeeDropdownOpen] = useState(false);
  const [searchEmployees, setSearchEmployees] = useState('');
  const [deviceUserRole, setDeviceUserRole] = useState<DeviceUserRoleResponse[]>([]);
  const [listEmployees, setListEmployees] = useState<EmployeesResponse[]>([]);
  const { isMobile, getWidth } = useResponsive();
  const kb = useFormKeyboard({ autoFocus: id === 'new' && !isMobile });
  const [formValues, setFormValues] = useState<DeviceUserPayload>({
    companyId: '',
    firstName: '',
    lastName: '',
    loginId: '',
    loginPin: '',
    nfcCode: '',
    emailAddress: '',
    deviceUserRoleId: '',
    statusId: 1,
    location: [
      {
        id: '',
      },
    ],
  });
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownUserRoleRef.current &&
        !dropdownUserRoleRef.current.contains(event.target as Node)
      ) {
        setIsUserRoleDropdownOpen(false);
      }
      if (
        dropdownEmployeeRef.current &&
        !dropdownEmployeeRef.current.contains(event.target as Node)
      ) {
        setIsEmployeeDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  useEffect(() => {
    if (window.languageContext) {
      setLanguage(window.languageContext.language);
    }
  }, [window, window.languageContext]);

  useEffect(() => {
    fecthUserRoleList();
    fetchListEmployees();
    if (id === 'new') {
      getListCountry();
    }
    if (id !== 'new') {
      fetchData();
    }
    const handleNewToken = async () => {
      fecthUserRoleList();
      fetchListEmployees();
      if (id === 'new') {
        getListCountry();
      }
      if (id !== 'new') {
        fetchData();
      }
    };
    document.addEventListener('newToken', handleNewToken);
    return () => {
      document.removeEventListener('newToken', handleNewToken);
    };
  }, [path]);

  const fecthUserRoleList = async (userRole?: DeviceUserRoleResponse) => {
    try {
      const response: any = await getListDeviceUserRole(1, 10, companyId, '');
      const listUserole: DeviceUserRoleResponse[] = response.data.data.deviceUserRole;
      setDeviceUserRole(listUserole);
    } catch (error) {
      console.log('🚀 ~ fecthUserRoleList ~ error:', error);
    }
  };

  const fetchListEmployees = async (employee?: EmployeesResponse) => {
    try {
      const data: EmployeePayload = {
        page: 1,
        limit: 10,
        searchValue: '',
        sort: 'DESC',
      };
      const response = await getListEmployees(data);
      const listEmp: EmployeesResponse[] = response.data.data;
      setListEmployees(listEmp);
    } catch (error) {
      console.log('🚀 ~ fetchListEmployees ~ error:', error);
    }
  };

  const fetchData = async () => {
    webLoadingTrue();
    try {
      const response = await getDetailDeviceUser(id, companyId);
      setFormValues({
        companyId: response.data.data.companyId,
        firstName: response.data.data.firstName,
        lastName: response.data.data.lastName,
        loginId: response.data.data.loginId,
        loginPin: response.data.data.loginPin,
        nfcCode: response.data.data.nfcCode,
        emailAddress: response.data.data.emailAddress,
        deviceUserRoleId: response.data.data.deviceUserRoleId,
        employeeId: response.data.data.employeeId,
        statusId: response.data.data.statusId,
        location: response.data.data.location,
      });
      if (response.data.data.employee) {
        setSearchEmployees(
          response.data.data.employee.firstName + ' ' + response.data.data.employee.lastName
        );
      }
      setSearchUserRole(response.data.data.deviceUserRole.roleName);
      setListCountrySelect(
        response.data.data.location.map((val: { id: string }) => {
          return { id: val.id };
        })
      );
      if (id !== 'new') {
        await getListCountry(response.data.data.location);
      }
    } catch (error) {
      console.error('Error loading terms:', error);
    } finally {
      webLoadingFalse();
    }
  };

  const getListCountry = async (listCountryFromProps?: ListCountryResponse[]) => {
    try {
      const response: any = await getLocations(userId, companyId, '', '', '');
      const listCountry: CountryResponse[] = response.data.data;
      console.log("🚀 ~ getListCountry ~ listCountry:", listCountry)
      let updateData = listCountry.map((val: any) => {
        return {
          ...val,
          isSelect: false,
        };
      });
      if (id !== 'new' && listCountryFromProps) {
        updateData = listCountry.map((val: any) => {
          return {
            ...val,
            isSelect: listCountryFromProps.some(attr => attr.locationId === val.id),
          };
        });
      }
      setCountry(updateData);
    } catch (error) {
      console.error('Error loading terms:', error);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
    const { name, value, type } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleToggle = (index: number, e: any) => {
    e.preventDefault();
    setCountry(prev => {
      const tempArr = [...prev];
      tempArr[index] = { ...tempArr[index], isSelect: !tempArr[index].isSelect };
      return tempArr;
    });
  };

  const handleSelectDeviceUserRole = (device: DeviceUserRoleResponse) => {
    console.log('🚀 ~ handleSelectDeviceUserRole ~ device:', device);
    setFormValues({ ...formValues, deviceUserRoleId: device.id });
    setSearchUserRole(device.roleName);
    setIsUserRoleDropdownOpen(false);
  };
  const handleSelectEmployees = (employee: EmployeesResponse) => {
    console.log('🚀 ~ handleSelectEmployees ~ employee:', employee);
    setFormValues({ ...formValues, employeeId: employee.id });
    setSearchEmployees(employee.firstName + ' ' + employee.lastName);
    setIsEmployeeDropdownOpen(false);
  };

  const handleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    const newErrors: any = validateAgainstLimits({ ...formValues, companyId } as any, limits, language, ['firstName', 'lastName', 'loginId', 'loginPin', 'nfcCode', 'emailAddress', 'deviceUserRoleId']);

    if (!formValues.firstName) {
      newErrors.firstName = 'First Name is required';
    }
    if (!formValues.lastName) {
      newErrors.lastName = 'Last Name is required';
    }
    if (!formValues.loginId) {
      newErrors.loginId = 'Login Id is required';
    }
    if (!formValues.loginPin) {
      newErrors.loginPin = 'Login Pin is required';
    }
    if (!formValues.deviceUserRoleId) {
      newErrors.deviceUserRoleId = 'Device User Role is required';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    webLoadingTrue();
    const payload: DeviceUserPayload = { ...formValues, companyId, location: country.filter((v) => v.isSelect).map((v) => ({ id: v.id })) };
    if (id === 'new') {
      try {
        const response: any = await createDeviceUser(payload);
        if (response) {
          webNavigate('/' + preLanguage + '/deviceUser');
          showToast({
            message: "Device User Created !",
            type: 'success',
            duration: 20000,
          });
          webLoadingFalse();
        }
      } catch (error: any) {
        webLoadingFalse();
        showApiError(error, { language, setFieldErrors: setErrors });
      }
    } else {
      try {
        const response: any = await updateDeviceUser(id, payload);
        if (response) {
          webNavigate('/' + preLanguage + '/deviceUser');
          showToast({
            message: language?.['Device User Updated !'] ?? 'Device User Updated !',
            type: 'success',
            duration: 20000,
          });
          webLoadingFalse();
        }
      } catch (error: any) {
        webLoadingFalse();
        showApiError(error, { language, setFieldErrors: setErrors });
      }
    }
  };

  return (
    <div {...kb.scopeProps}>
      <div className="bg-white">
        <div className="flex items-center ">
          <button
            type="button"
            aria-label={language?.['Back'] ?? 'Back'}
            className="w-6 h-6 flex items-center justify-center cursor-pointer"
            onClick={() => {
              webNavigate('/' + preLanguage + '/deviceUser');
            }}
          >
            <BackIcon />
          </button>
          <p
            style={{ fontSize: '14px', fontWeight: '500', lineHeight: '28px', color: '#222525' }}
            className="font-inter"
          >
            {language && language?.['Back'] ? language?.['Back'] : 'Back'}
          </p>
        </div>
      </div>
      <form style={{ height: 'calc(100% - 115px)' }}>
        <div className="flex items-start scroll-container" style={{ gap: "20px", height: '100%', flexWrap: "wrap", overflow: 'scroll', marginTop: "24px", paddingBottom: isMobile ? '16px' : '' }}>
          <div style={{ width: isMobile ? "100%" : "calc(25% - 10px)" }}>
            <div style={{ width: '100%', padding: "20px", border: '1px solid #DBE4E4', borderRadius: '12px' }}>
              <div className="flex items-center gap-x-2">
                <div className="w-6 h-6 flex items-center justify-center">
                  <LocationsIcon />
                </div>
                <p className="font-inter " style={{ fontSize: '16px', fontWeight: "500", lineHeight: "130%", color: "#222525" }}>
                  {language?.['Location access'] ?? 'Location access'}
                </p>
              </div>
              <div style={{ marginTop: "20px" }} className="">
                {country.map((val, index) => {
                  return (
                    <div className="flex items-center" style={{ marginTop: "16px", gap: '8px' }}>
                      <button
                        type="button"
                        role="checkbox"
                        aria-checked={!!val.isSelect}
                        aria-label={val?.name}
                        onClick={(e: any) => { handleToggle(index, e) }}
                        // Toggles on Space only, like a native checkbox; plain Enter does not activate it.
                        onKeyDown={(e) => { if (e.key === 'Enter' && !e.ctrlKey && !e.metaKey) e.preventDefault(); }}
                        style={{
                          width: '20px',
                          height: '20px',
                          borderRadius: '6px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          transition: 'all 0.2s',
                          backgroundColor: val.isSelect ? '#0F7679' : 'white',
                          border: val.isSelect ? 'none' : '2px solid #d1d5db',
                          color: 'white'
                        }}
                      >
                        {val.isSelect && <CheckIconWhite />}
                      </button>
                      <div >
                        <p className="text-[14px] leading-[20px] font-inter font-medium" style={{ color: "#222525" }}>{val?.name}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div style={{ width: isMobile ? "100%" : "calc(75% - 10px)", }}>
            {id === 'new' ? (
              <p
                style={{
                  marginBottom: '20px',
                  fontSize: '20px',
                  fontWeight: '500',
                  lineHeight: '28px',
                  color: '#222525',
                }}
                className="font-inter"
              >
                {language && language?.['Add Device User']
                  ? language?.['Add Device User']
                  : 'Add Device User'}
              </p>
            ) : (
              <p
                style={{
                  marginBottom: '20px',
                  fontSize: '20px',
                  fontWeight: '500',
                  lineHeight: '28px',
                  color: '#222525',
                }}
                className="font-inter"
              >
                {language && language?.['Edit Device User']
                  ? language?.['Edit Device User']
                  : 'Edit Device User'}
              </p>
            )}
            <div
              className="flex items-center"
              style={{ flexWrap: 'wrap', gap: 24 }}
            >
              <div className="space-y-2" style={{ width: 'calc(50% - 12px)' }}>
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: '#4A5353', fontWeight: '500' }}
                  >
                    {language && language?.['First Name'] ? language?.['First Name'] : 'First Name'}
                  </p>
                  <p className="text-[14px] font-inter leading-[20px]" style={{ color: '#BA0E13' }}>
                    {language && language?.['*'] ? language?.['*'] : '*'}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    type="text"
                    name="firstName"
                    {...limitProps(limits, 'firstName')}
                    value={formValues.firstName}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                  <FieldCounter value={formValues.firstName} max={limits.firstName?.maxLength} />
                </div>
                {errors.firstName && <p className="error">{errors.firstName}</p>}
              </div>
              <div className="space-y-2" style={{ width: 'calc(50% - 12px)' }}>
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: '#4A5353', fontWeight: '500' }}
                  >
                    {language && language?.['Last Name'] ? language?.['Last Name'] : 'Last Name'}
                  </p>
                  <p className="text-[14px] font-inter leading-[20px]" style={{ color: '#BA0E13' }}>
                    {language && language?.['*'] ? language?.['*'] : '*'}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    type="text"
                    name="lastName"
                    {...limitProps(limits, 'lastName')}
                    value={formValues.lastName}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                  <FieldCounter value={formValues.lastName} max={limits.lastName?.maxLength} />
                </div>
                {errors.lastName && <p className="error">{errors.lastName}</p>}
              </div>
              <div className="space-y-2" style={{ width: '100%' }}>
                <div className="flex items-center justify-between">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: '#4A5353', fontWeight: '500' }}
                  >
                    {language && language?.['Email address'] ? language?.['Email address'] : 'Email address'}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    type="text"
                    name="emailAddress"
                    {...limitProps(limits, 'emailAddress')}
                    value={formValues.emailAddress}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                  <FieldCounter value={formValues.emailAddress} max={limits.emailAddress?.maxLength} />
                </div>
                {errors.emailAddress && <p className="error">{errors.emailAddress}</p>}
              </div>
              <div className="space-y-2" style={{ width: isMobile ? '100%' : 'calc(50% - 12px)' }}>
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: '#4A5353', fontWeight: '500' }}
                  >
                    {language && language?.['Login Id'] ? language?.['Login Id'] : 'Login Id'}
                  </p>
                  <p className="text-[14px] font-inter leading-[20px]" style={{ color: '#BA0E13' }}>
                    {language && language?.['*'] ? language?.['*'] : '*'}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    type="text"
                    name="loginId"
                    autoComplete="off"
                    {...limitProps(limits, 'loginId')}
                    value={formValues.loginId}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                  <FieldCounter value={formValues.loginId} max={limits.loginId?.maxLength} />
                </div>
                {errors.loginId && <p className="error">{errors.loginId}</p>}
              </div>
              <div className="space-y-2" style={{ width: isMobile ? '100%' : 'calc(50% - 12px)' }}>
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: '#4A5353', fontWeight: '500' }}
                  >
                    {language && language?.['Login Pin'] ? language?.['Login Pin'] : 'Login Pin'}
                  </p>
                  <p className="text-[14px] font-inter leading-[20px]" style={{ color: '#BA0E13' }}>
                    {language && language?.['*'] ? language?.['*'] : '*'}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    type="password"
                    name="loginPin"
                    autoComplete="new-password"
                    {...limitProps(limits, 'loginPin')}
                    value={formValues.loginPin}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                  <FieldCounter value={formValues.loginPin} max={limits.loginPin?.maxLength} />
                </div>
                {errors.loginPin && <p className="error">{errors.loginPin}</p>}
              </div>
              <div className="space-y-2" style={{ width: isMobile ? '100%' : 'calc(50% - 12px)' }}>
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: '#4A5353', fontWeight: '500' }}
                  >
                    {language && language?.['Device User Role']
                      ? language?.['Device User Role']
                      : 'Device User Role'}
                  </p>
                  <p className="text-[14px] font-inter leading-[20px]" style={{ color: '#BA0E13' }}>
                    {language && language?.['*'] ? language?.['*'] : '*'}
                  </p>
                </div>
                <div className="w-full">
                  <DropdownSearch
                    refKey="userRole"
                    refs={{ userRole: dropdownUserRoleRef }}
                    openStates={{ userRole: isUserRoleDropdownOpen }}
                    open={(key) => key === "userRole" && setIsUserRoleDropdownOpen(true)}
                    close={(key) => key === "userRole" && setIsUserRoleDropdownOpen(false)}
                    data={deviceUserRole}
                    labelExtractor={(item) => item.roleName}
                    value={searchUserRole}
                    setValue={setSearchUserRole}
                    onSelect={handleSelectDeviceUserRole}
                    error={errors.deviceUserRoleId}
                    borderNone={false}
                    autoComplete="off"
                  />
                </div>
              </div>
              <div className="space-y-2" style={{ width: isMobile ? '100%' : 'calc(50% - 12px)' }}>
                <div className="flex items-center justify-between">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: '#4A5353', fontWeight: '500' }}
                  >
                    {language && language?.['NFC Code'] ? language?.['NFC Code'] : 'NFC Code'}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    type="text"
                    name="nfcCode"
                    autoComplete="off"
                    {...limitProps(limits, 'nfcCode')}
                    value={formValues.nfcCode}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                  <FieldCounter value={formValues.nfcCode} max={limits.nfcCode?.maxLength} />
                </div>
                {errors.nfcCode && <p className="error">{errors.nfcCode}</p>}
              </div>
              <div className="space-y-2" style={{ width: '100%' }}>
                <div className="flex items-center justify-between">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: '#4A5353', fontWeight: '500' }}
                  >
                    {language && language?.['Map to an employee record']
                      ? language?.['Map to an employee record']
                      : 'Map to an employee record'}
                  </p>
                </div>
                <div className="w-full">
                  <DropdownSearch
                    refKey="employee"
                    refs={{ employee: dropdownEmployeeRef }}
                    openStates={{ employee: isEmployeeDropdownOpen }}
                    open={(key) => key === "employee" && setIsEmployeeDropdownOpen(true)}
                    close={(key) => key === "employee" && setIsEmployeeDropdownOpen(false)}
                    data={listEmployees}
                    labelExtractor={(item) => item?.firstName + ' ' + item?.lastName}
                    value={searchEmployees}
                    setValue={setSearchEmployees}
                    onSelect={handleSelectEmployees}
                    error={errors.locationId}
                    borderNone={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div
        className="w-full flex items-center justify-end shadow_button relative"
        style={{ gap: "12px", paddingTop: "24px", }}
      >
        <div className="absolute" style={{ left: "-24px", top: 0, height: "1px", backgroundColor: "#DBE4E4", width: isMobile ? 'calc(100vw + 32px)' : "calc(-256px + 48px + 100vw)" }}></div>
        <button
          type="button"
          onClick={() => { webNavigate("/" + preLanguage + '/deviceUser') }}
          style={{
            padding: '10px 24px',
            borderRadius: '30px',
            color: '#222525',
            fontSize: '14px',
            fontWeight: '500',
            border: '1px solid #C9D7D8',
          }}
          className="font-inter cursor-pointer"
        >
          {language && language?.['Cancel'] ? language?.['Cancel'] : 'Cancel'}
        </button>
        <button type="button" style={{
          padding: '10px 24px',
          borderRadius: '30px',
          color: '#FFFFFF',
          fontSize: '14px',
          fontWeight: '500',
          backgroundColor: '#0F7679',
        }}
          className="font-inter cursor-pointer"
          {...kb.primaryProps(handleSubmit)}
        >
          <p className="text-[14px] leading-[22px] font-inter">{language && language?.["Save"] ? language?.["Save"] : "Save"}</p>
        </button>
      </div>
    </div>
  );
};
export default DeviceUserDetail;
